export function getQueryString(url: string, name: string): string {
  //eslint-disable-next-line
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
    urlStr = url ? url : window.location.search,
    results = regex.exec(urlStr);
  return results === null
    ? ""
    : decodeURIComponent(results[1].replace(/\+/g, " "));
}

export default function wrappedWindowUrl(key: string) {
  return getQueryString(window.location.href, key);
}

export const testIsHeraeus = () => {
  return (Number.parseInt(wrappedWindowUrl('companyID'), 10) === 12)
}

export const replaceQuery = (
  name = "",
  value = "",
  url = window.location.href
) => {
  url = decodeURIComponent(url);
  // 新的搜索参数
  let newQuery = "";

  // 如果有参数
  let search = url.match(/[?]([^#]+)/);
  if (search) {
    // URL 剔除所有参数
    url = url.replace(search[0], "");

    let querys = search[1].split("&");
    let queryObj: any = {};
    querys.forEach((i: any) => {
      let rems = i.split("=");
      // 剔除当前的参数
      if (rems[0] !== name) {
        queryObj[rems[0]] = rems[1];
      }
    });
    newQuery = Object.keys(queryObj)
      .map((i) => `${i}=${queryObj[i]}`)
      .join("&");
  }

  if (value) {
    newQuery = newQuery ? `${newQuery}&${name}=${value}` : `${name}=${value}`;
  }
  return newQuery ? `${url}?${newQuery}` : url;
};
